<template>
  <div id="consulting-topic-detail">
    <v-container grid-list-xl>
      <transition name="fade">
        <!-- Section 1 -->
        <template v-if="!selectedTopic && !selectedBeneficary">
          <v-layout align-center justify-center row wrap>
            <!-- Header -->
            <v-flex mt-5 xs11>
              <div class="headline font-weight-bold">ศูนย์ให้คำปรึกษา</div>
              <div class="headline font-weight-bold">ปัญหาด้านธุรกิจเกษตร</div>
              <div class="caption grey--text mt-2">
                เพราะเราให้ความสำคัญในทุกๆปัญหาด้านธุรกิจเกษตร
              </div>
              <div class="caption grey--text">กรุณาเลือกปัญหาที่คุณสนใจที่เมนูด้านล่าง</div>
            </v-flex>
            <!-- Content -->
            <v-flex
              :key="consultingTopic.idx"
              py-1
              v-for="consultingTopic in consultingTopics"
              xs11
            >
              <v-card @click="onChooseTopic(consultingTopic.idx)" color="#E2F0D9" elevation="0">
                <v-card-title class="pt-4 pb-0">
                  <div class="subheading">{{ consultingTopic.name }}</div>
                </v-card-title>
                <v-card-text class="pt-2">
                  <ul
                    :key="filterBeneficiary.idx"
                    v-for="filterBeneficiary in getBeneficiaryByTopic(consultingTopic.idx)"
                  >
                    <li class="caption grey--text">{{ filterBeneficiary.name }}</li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex text-xs-right xs11>
              <v-btn @click="$router.push({ name: 'home' })">กลับ</v-btn>
            </v-flex>
          </v-layout>
        </template>
        <!-- Section 2 -->
        <template v-else-if="selectedTopic && !selectedBeneficary">
          <v-layout align-center justify-center row wrap>
            <!-- Header -->
            <v-flex mt-5 xs11>
              <div class="headline font-weight-bold">{{ filterTopics.name }}</div>
              <div class="caption grey--text">กรุณาระบุปัญหาที่ตรงกับคุณมากที่สุด</div>
            </v-flex>
            <!-- Content -->
            <v-flex
              :key="filterBeneficiary.idx"
              py-1
              v-for="filterBeneficiary in getBeneficiaryByTopic(selectedTopic)"
              xs11
            >
              <v-card
                @click="onChooseBeneficiary(filterBeneficiary.idx)"
                color="#E2F0D9"
                elevation="0"
              >
                <v-card-title class="pt-4 pb-0">
                  <div class="subheading">{{ filterBeneficiary.name }}</div>
                </v-card-title>
                <v-card-text class="pt-2">
                  <div class="caption grey--text">{{ filterBeneficiary.description || '' }}</div>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex text-xs-right xs11>
              <v-btn @click="selectedTopic = null">กลับ</v-btn>
            </v-flex>
          </v-layout>
        </template>
        <!-- Section 3 -->
        <template v-else>
          <v-layout align-center justify-center row wrap>
            <!-- Header -->
            <v-flex mt-5 pb-0 xs11>
              <div class="headline font-weight-bold">{{ filterTopics.name }}</div>
              <div class="caption">{{ filterBeneficiarys.name }}</div>
            </v-flex>
            <!-- Content -->
            <v-flex text-xs-right xs11>
              <form @submit.prevent="sendProblem('form-1')" data-vv-scope="form-1">
                <v-textarea
                  class="consulting-box mb-2"
                  data-vv-as="textarea"
                  data-vv-name="problems"
                  hide-details
                  placeholder="กรุณาอธิบายปัญหาที่คุณพบเจอ"
                  rows="4"
                  solo
                  v-model="problems"
                  v-validate="'required'"
                ></v-textarea>
                <span class="caption" style="color:red">{{ errors.first('form-1.problems') }}</span>
                <v-btn @click="selectedBeneficary = null" depressed>กลับ</v-btn>
                <v-btn color="primary" depressed type="submit">แจ้งปัญหา</v-btn>
              </form>
            </v-flex>
          </v-layout>
        </template>
      </transition>
    </v-container>
    <!-- Dialog Info -->
    <v-dialog max-width="400px" v-model="dialog">
      <form @submit.prevent="doSubmit('form-2')" data-vv-scope="form-2">
        <v-card>
          <v-card-text>
            <v-container grid-list-xl pa-0>
              <v-layout class="consulting-box" justify-center row wrap>
                <v-flex text-xs-center xs12>
                  <div class="display-1 font-weight-bold">กรุณายืนยันตัวตน</div>
                </v-flex>
                <v-flex text-xs-center xs12>
                  <FacebookLogin
                    @firstname="formData.firstname = $event"
                    @lastname="formData.lastname = $event"
                    @phone="formData.phone = $event"
                  />
                </v-flex>
                <v-flex py-1 text-xs-center xs12>
                  <div class="title">หรือ</div>
                </v-flex>
                <v-flex pb-0 xs12>
                  <v-text-field
                    :error-messages="errors.collect('form-2.firstname')"
                    data-vv-name="firstname"
                    label="ชื่อ"
                    solo
                    v-model="formData.firstname"
                    v-validate="'required'"
                  ></v-text-field>
                  <v-text-field
                    :error-messages="errors.collect('form-2.lastname')"
                    data-vv-name="lastname"
                    label="นามสกุล"
                    solo
                    v-model="formData.lastname"
                    v-validate="'required'"
                  ></v-text-field>
                  <v-text-field
                    :error-messages="errors.collect('form-2.phone')"
                    data-vv-name="phone"
                    label="เบอร์โทรศัพท์"
                    mask="###-###-####"
                    solo
                    v-model="formData.phone"
                    v-validate="'numeric|required'"
                  ></v-text-field>
                  <base-autocomplete-place
                    :verticalMode="true"
                    @countryId="formData.countryId = $event"
                    @districtId="formData.districtId = $event"
                    @provinceId="formData.provinceId = $event"
                    @regionId="formData.regionId = $event"
                    @subDistrictId="formData.subDistrictId = $event"
                  ></base-autocomplete-place>
                </v-flex>
                <v-flex pt-0 text-xs-right xs12>
                  <v-btn :loading="dialogLoading" color="green" dark type="submit"
                    >ยืนยันผู้แจ้งปัญหา</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </form>
    </v-dialog>
  </div>
</template>

<script>
const FacebookLogin = () => import('../components/consultings/FacebookLogin.vue')
export default {
  name: 'consulting-topic-detail',
  components: {
    FacebookLogin
  },
  data() {
    return {
      selectedTopic: null,
      selectedBeneficary: null,
      dialog: false,
      dialogLoading: false,
      problems: ''
    }
  },
  computed: {
    formData: {
      // getter
      get() {
        return this.$store.state.FbLogin.data
      },
      // setter
      set() {}
    },
    filterTopics() {
      return this.$store.getters['ConsultingTopic/getAll'].filter(
        item => item.idx == this.selectedTopic
      )[0]
    },
    filterBeneficiarys() {
      return this.$store.getters['ConsultingBeneficiary/getAll'].filter(
        item => item.idx == this.selectedBeneficary
      )[0]
    },
    consultingTopics() {
      return this.$store.getters['ConsultingTopic/getAll']
    },
    consultingBeneficiarys() {
      return this.$store.getters['ConsultingBeneficiary/getAll']
    }
  },
  async created() {
    await this.$store.dispatch('ConsultingTopic/fetch')
    await this.$store.dispatch('ConsultingBeneficiary/fetch')
  },
  methods: {
    getBeneficiaryByTopic(consultingTopicId) {
      return this.$store.getters['ConsultingBeneficiary/getAll'].filter(
        item => item.consultingTopicId == consultingTopicId
      )
    },
    onChooseTopic(topicId) {
      this.selectedTopic = topicId
    },
    onChooseBeneficiary(beneficiaryId) {
      this.selectedBeneficary = beneficiaryId
    },
    async sendProblem(scope) {
      try {
        const dict = {
          custom: {
            problems: {
              required: 'กรุณาระบุปัญหา'
            }
          }
        }
        // or use the instance method
        this.$validator.localize('th', dict)
        const validate = await this.$validator.validateAll(scope)
        if (validate) {
          this.$store.commit('FbLogin/SET', [])
          this.dialog = !this.dialog
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    async doSubmit(scope) {
      try {
        const validate = await this.$validator.validateAll(scope)
        if (validate) {
          this.dialogLoading = !this.dialogLoading
          // check user
          const data = {
            ...this.formData
            // createdBy: localStorage.getItem('tokenAdmin')
          }
          const userId = await this.$store.dispatch(`ConsultingCase/checkUserInfo`, data)
          const problem = {
            userId: userId,
            problems: this.problems,
            consultingBeneficiaryId: this.selectedBeneficary
          }
          await this.$store.dispatch(`ConsultingCase/insert`, problem)
          this.problems = []
          this.dialogLoading = !this.dialogLoading
          this.dialog = !this.dialog
          this.$store.dispatch('Notification/add', {
            type: 'success',
            message: 'เราได้รับคำแจ้งของคุณแล้ว พนักงานจะติดต่อกลับโดยเร็ววัน'
          })
          setTimeout(() => {
            location.reload()
          }, 2500)
        }
      } catch (error) {
        this.dialogLoading = !this.dialogLoading
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
